module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hle9N"))).then(() => module.bundle.root('d0iPb'));